<template>
  <div v-show="tipsCfg.visible && tipsCfg.tipsData?.id" ref="componentRef" class="modal-overlay" @click="hiddenTips">
    <div class="xy-goods-tips" @click.stop :style="tipsCfg.style">
      <div class="pic-box" :style="{ ...tipsCfg.picBoxStyle, padding: computeRatioPx(28), backgroundImage: `url('${tipsCfg.picBoxStyle.backgroundImage}')` }">
        <div :class="[tipsCfg.language !== 'ar' ? 'text-rtl' : 'text-ltr']">
          <div class="bg-grey flex-row" :style="{ ...getCornerTextStyle, width: 'fit-content', position: 'relative' }" v-if="tipsCfg.tipsData.goodsValue && tipsCfg.tipsData.goodsValueType">
            <img :style="{ maxWidth: computeRatioPx(40), maxHeight: computeRatioPx(40) }" src="@/packages/assets/images/coin.png" v-if="Number(tipsCfg.tipsData.goodsValueType) === 1" />
            <img :style="{ maxWidth: computeRatioPx(40), maxHeight: computeRatioPx(40) }" src="@/packages/assets/images/diamond.png" v-else />
            <p :style="{ marginRight: computeRatioPx(8) }">{{ tipsCfg.tipsData.goodsValue }}</p>
          </div>
        </div>
        <div class="pic-box-img text-center">
          <img :style="{ ...tipsCfg.picImgStyle, margin: '0 auto' }" :src="tipsCfg.tipsData.picUrl" />
        </div>
        <!-- <div v-if="tipsCfg.tipsData.backpackCategoryName" :class="[tipsCfg.language !== 'ar' ? 'text-rtl' : 'text-ltr']">
          <span class="bg-grey" :style="getCornerTextStyle">
            {{ tipsCfg.tipsData.backpackCategoryName }}
          </span>
        </div> -->
      </div>
      <div class="content-box" :style="{ padding: computeRatioPx(28), flex: 1, backgroundColor: '#fff' }">
        <p class="text-center" :style="{ ...tipsCfg.descTitleStyle, marginBottom: tipsCfg.tipsData?.configurationId?.includes('Gift') ? computeRatioPx(16) : computeRatioPx(30) }">
          {{ tipsCfg.tipsData.name }}
        </p>
        <div v-if="tipsCfg.tipsData.expireTime" class="text-center" :style="{ marginBottom: computeRatioPx(20) }">
          <span class="bg-grey flex-row" :style="getTimeTextStyle">
            <img :style="{ marginRight: computeRatioPx(8), width: computeRatioPx(28), height: computeRatioPx(28) }" src="@/packages/assets/images/clock.svg" />
            <span v-if="tipsCfg.tipsData.expireTime === '0'">{{ LGSdk.t('tips.forever') }}</span>
            <template v-else>
              <span :class="[tipsCfg.language !== 'ar' ? 'text-ltr' : 'text-rtl']">{{ tipsCfg.tipsData.expireTime + ` ${LGSdk.t('tips.day')}` }}</span>
            </template>
          </span>
        </div>
        <p :class="[tipsCfg.language !== 'ar' ? 'text-ltr' : 'text-rtl']" :style="tipsCfg.descContentStyle">
          {{ tipsCfg.tipsData.introduction }}
        </p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import { info, defaultProps } from './config'
import { useTips } from '@/packages/components/hook/useTips'
import { computeRatioPx } from '@/packages/plugins/utils'
import { TIPS_STYLE, TIPS_PIC_BOX_STYLE, TIPS_PIC_IMG_STYLE, TIPS_DESC_TITLE_STYLE, TIPS_DESC_CONTENT_STYLE, IMG_MAP } from './constant'
import LGSdk from '@/packages/plugins/languageSDK/index'

defineOptions({ name: info.name })
const props = defineProps(defaultProps)

const tipsCfg = ref({
  style: {
    width: 600,
    height: 750,
    borderRadius: 30
  },
  picBoxStyle: {
    width: '100%',
    height: 500,
    backgroundSrc: ''
  },
  picImgStyle: {
    width: 200,
    height: 200
  },
  descTitleStyle: {
    fontSize: 24,
    fontWeight: 600,
    color: '#fff'
  },
  descContentStyle: {
    fontSize: 20,
    fontWeight: 500,
    color: '#f5f5f5'
  },
  language: 'en',
  visible: false,
  tipsData: {}
})

const initPage = () => {
  tipsCfg.value.style = {
    width: computeRatioPx(TIPS_STYLE.width),
    /*  height: computeRatioPx(TIPS_STYLE.height), */
    borderRadius: computeRatioPx(TIPS_STYLE.borderRadius)
  }
  tipsCfg.value.picBoxStyle = {
    width: TIPS_PIC_BOX_STYLE.width,
    height: computeRatioPx(TIPS_PIC_BOX_STYLE.height),
    backgroundImage: props.backgroundSrc ? IMG_MAP[props.backgroundSrc] : '',
    backgroundSize: 'cover'
  }
  tipsCfg.value.picImgStyle = {
    width: computeRatioPx(TIPS_PIC_IMG_STYLE.width),
    height: computeRatioPx(TIPS_PIC_IMG_STYLE.height),
    objectFit: 'contain'
  }
  tipsCfg.value.descTitleStyle = {
    fontSize: computeRatioPx(TIPS_DESC_TITLE_STYLE.fontSize),
    fontWeight: computeRatioPx(TIPS_DESC_TITLE_STYLE.fontWeight),
    color: TIPS_DESC_TITLE_STYLE.color
  }
  tipsCfg.value.descContentStyle = {
    fontSize: computeRatioPx(TIPS_DESC_CONTENT_STYLE.fontSize),
    fontWeight: computeRatioPx(TIPS_DESC_CONTENT_STYLE.fontWeight),
    color: TIPS_DESC_CONTENT_STYLE.color,
    whiteSpace: 'pre-line'
  }
}

const initTips = (initTipsData, language) => {
  tipsCfg.value.tipsData = initTipsData
  tipsCfg.value.language = language
  tipsCfg.value.visible = true
}

const hiddenTips = () => {
  tipsCfg.value.visible = false
  tipsCfg.value.tipsData = {}
}

const getCornerTextStyle = computed(() => {
  return {
    padding: computeRatioPx(8),
    paddingLeft: computeRatioPx(20),
    paddingRight: computeRatioPx(20),
    borderRadius: computeRatioPx(8),
    fontSize: computeRatioPx(28)
  }
})

const getTimeTextStyle = computed(() => {
  return {
    color: '#fff',
    width: 'fit-content',
    margin: '0 auto',
    padding: computeRatioPx(6),
    paddingLeft: computeRatioPx(16),
    paddingRight: computeRatioPx(16),
    borderRadius: computeRatioPx(16)
  }
})

/* const getExpireTime = (id) => {
  const dayStr = id.substring(id.length - 2)
  return Number(dayStr[0]) ? dayStr : dayStr[1]
} */

const { componentRef, getConfig, showTips } = useTips(props, initTips)

onMounted(() => {
  initPage()
})

defineExpose({
  getConfig,
  showTips,
  hiddenTips
})
</script>

<style lang="scss" scoped>
.xy-goods-tips {
  /* height: 100%;
  width: 100%; */
  z-index: 1001;
}
.pic-box {
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
  &-img {
    flex: 1;
    display: flex;
    align-items: center;
  }
}
.content-box {
  border-bottom-left-radius: inherit;
  border-bottom-right-radius: inherit;
}
.text-center {
  text-align: center;
}
.text-ltr {
  text-align: left;
  direction: ltr;
  line-height: 1.3;
}
.text-rtl {
  text-align: right;
  direction: rtl;
  line-height: 1.3;
}
.bg-grey {
  background: #d9d9d9;
}
.flex-row {
  display: flex;
  align-items: center;
  justify-content: center;
}
.modal-overlay {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  width: 100% !important;
  height: 100% !important;
  border-radius: 0 !important;
  margin: 0 !important;
  background-color: rgba(0, 0, 0, 0.5); /* 透明灰黑色背景 */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  overflow-y: auto;
}
</style>
